export const HOME_STRINGS = {
  en: {
    TITLE: 'All\u00A0training. One\u00A0membership.',
    DESCRIPTION:
      'Get access to more than 1000 gyms, yoga studios, climbing centers, dance classes, HIIT boxes & swimming pools.',
    TRIAL_BUTTON: 'Try Bruce Studios for 14 days',
    JOIN_BUTTON: 'Join Bruce Studios',
    EXPLORE_BUTTON: 'Explore all studios',
    AMBASSADORS: [
      {
        name: 'Irene Ekelund',
        image: '/images/ambassadors/irene-ekelund.webp',
        description: 'Track athlete, 100m & 200m',
        quote:
          'Bruce Studios is perfect for me to get the variety I need in my training to reach my goals in my elite career in athletics!',
      },
      {
        name: 'Amanda Colldén',
        image: '/images/ambassadors/amanda-collden.webp',
        description: 'Entrepreneur & podcaster',
        quote:
          "I've been a member and big fan of Bruce Studios since I heard about it a few years ago! Exercise is a super important part of my life and with Bruce studios' help it's easy to get the variety that experts say is so important. I do yoga, go to HIT classes, do OCR and dance via Bruce Studios. Love it!",
      },
      {
        name: 'Simon Carlfjord',
        image: '/images/ambassadors/simon-carlfjord.webp',
        description: 'Personal Trainer, Founder of Ignite Training Hub',
        quote:
          'With Bruce Studios, I can both sweat at my favorite studios AND have the opportunity to experiment with new exciting classes! That mix helps me keep my motivation and training joy at the top!',
      },
      {
        name: 'Adjani Benita Goli',
        image: '/images/ambassadors/adjani-benita-goli.webp',
        description: 'Founder & CEO, Sthlm Dance Agency',
        quote:
          "I have always loved to vary my training. In addition to the dance that I work with, I activate myself in other ways to become more versatile and because it's fun to try new types of workouts. With Bruce Studios, this is incredibly easy and smooth.",
      },
      {
        name: 'Jenny Freed',
        image: '/images/ambassadors/jenny-freed.webp',
        description: 'Training profile & lecturer',
        quote:
          'Bruce Studios concept is revolutionary for those who already LOVE everything about training, but also for those who have difficulties finding joy in exercise. I just love Bruce Studios.',
      },
      {
        name: 'Susanna Moen',
        image: '/images/ambassadors/susanna-moen.webp',
        description: 'Founder & trainer, women.sync',
        quote:
          "I've had Bruce Studios for the past year and I love it! I love to be able to work out in different places, test new classes and vary my training depending on where I am.",
      },
    ],
    WHY_BRUCE_TITLE: 'Why Bruce Studios?',
    WHY_BRUCE_ITEMS: [
      {
        ICON: 'ph-shuffle',
        TITLE: 'Vary your workouts',
        DESCRIPTION:
          'All forms of exercise you can think of - from gym and swimming, to yoga, paddle and crossfit and everything in between.',
      },
      {
        ICON: 'ph-sparkle',
        TITLE: 'Unique experiences',
        DESCRIPTION:
          'Work out in unique boutique studios reminding you of everything from a nightclub in L.A. to a yoga retreat in India.',
      },
      {
        ICON: 'ph-hand-fist',
        TITLE: 'Freedom',
        DESCRIPTION:
          'Work out whatever and wherever you want. No commitment and you can pause your membership at any time.',
      },
    ],
  },
  sv: {
    TITLE: 'All\u00A0training. One\u00A0membership.',
    DESCRIPTION:
      'Get access to more than 1000 gyms, yoga studios, climbing centers, dance classes, HIIT boxes & swimming pools.',
    TRIAL_BUTTON: 'Prova gratis 14 dagar',
    JOIN_BUTTON: 'Joina Bruce Studios',
    EXPLORE_BUTTON: 'Utforska alla studios',
    AMBASSADORS: [
      {
        name: 'Irene Ekelund',
        image: '/images/ambassadors/irene-ekelund.webp',
        description: 'Friidrottare, 100m & 200m',
        quote:
          'Bruce Studios är perfekt för mig att få variation i min träning mot mina mål i min elitsatsning inom friidrotten!',
      },
      {
        name: 'Amanda Colldén',
        image: '/images/ambassadors/amanda-collden.webp',
        description: 'Entreprenör & poddare',
        quote:
          'Varit medlem och stort fan av Bruce Studios sen jag hörde talas om att det fanns för några år sen! Träning är en superviktig del av mitt liv och med hjälp av Bruce Studios blir det lätt att få den variationen som experter säger är så viktig. Jag kör yoga, går på HIT-klasser, kör OCR och dansar via Bruce Studios. Älskar det!',
      },
      {
        name: 'Simon Carlfjord',
        image: '/images/ambassadors/simon-carlfjord.webp',
        description: 'Personlig tränare och grundare av Ignite Training Hub',
        quote:
          'Med hjälp av Bruce Studios kan jag både svettas på mina favoritkoncept samtidigt som jag har möjlighet att experimentera med nya spännande klasser! Den mixen hjälper mig att hålla min motivation och träningsglädje på topp!',
      },
      {
        name: 'Adjani Benita Goli',
        image: '/images/ambassadors/adjani-benita-goli.webp',
        description: 'Grundare & CEO, Sthlm Dance Agency',
        quote:
          'Jag har alltid älskat att variera min träning, förutom dansen som jag jobbar med så aktiverar jag mig på andra sätt för att bli mer mångsidig, och för att det är roligt att testa nya träningsformer. Med Bruce Studios blir detta otroligt enkelt och smidigt.',
      },
      {
        name: 'Jenny Freed',
        image: '/images/ambassadors/jenny-freed.webp',
        description: 'Träningsprofil & föreläsare',
        quote:
          'Bruce Studios är en revolutionerande app och möjlighet som öppnar upp rum för andra som kanske har det svårt att hitta sin glädjekälla i träning, samt ger möjlighet för den personen som ÄLSKAR allt med träning, vill utmana sig eller prova på nytt som gör att du bibehåller rutiner till träningen. Jag älskar Bruce Studios helt enkelt.',
      },
      {
        name: 'Susanna Moen',
        image: '/images/ambassadors/susanna-moen.webp',
        description: 'Grundare & tränare, women.sync',
        quote:
          'Jag har kört Bruce Studios det senaste året och jag älskar konceptet! Älskar att kunna träna på olika studios, testa nya klasser och variera min träning utifrån den plats jag är på.',
      },
    ],
    WHY_BRUCE_TITLE: 'Varför Bruce Studios?',
    WHY_BRUCE_ITEMS: [
      {
        ICON: 'ph-shuffle',
        TITLE: 'Variera din träning',
        DESCRIPTION:
          'Träna alltifrån gym, simning, klättring, yoga, padel, crossfit och allt däremellan.',
      },
      {
        ICON: 'ph-sparkle',
        TITLE: 'Unika upplevelser',
        DESCRIPTION:
          'Träna på unika boutique-studios som påminner om allt från en nattklubb i L.A. till ett yogaretreat i Indien.',
      },
      {
        ICON: 'ph-hand-fist',
        TITLE: 'Frihet',
        DESCRIPTION:
          'Träna vad och var du vill. Ingen bindningstid och pausa ditt medlemskap när du vill.',
      },
    ],
  },
  nb: {
    TITLE: 'All\u00A0training. One\u00A0membership.',
    DESCRIPTION:
      'Get access to more than 1000 gyms, yoga studios, climbing centers, dance classes, HIIT boxes & swimming pools.',
    TRIAL_BUTTON: 'Prøv gratis i 14 dager',
    JOIN_BUTTON: 'Join Bruce Studios',
    EXPLORE_BUTTON: 'Utforsk alle studios',
    AMBASSADORS: [
      {
        name: 'Martin Skadal',
        image: '/images/ambassadors/martin-skadal.webp',
        description: 'Entreprenør, Public speaker, Greenfluencer',
        quote:
          'Tror på ekte Bruce Studios er en relativt billig måte å øke folkehelsen, livsmestringen og livsgleden til samfunnet. Jeg selv og flere jeg har møtt som bruker Bruce Studios elsker det fordi man kan velge mellom så mange ulike aktiviteter for både trening, restitusjon og for å være sosial.',
      },
      {
        name: 'Hedvig Wessel',
        image: '/images/ambassadors/hedvig-wessel.webp',
        description: 'Idrettsutøver, 2x Olympian',
        quote:
          'Avhengig av hvor jeg er, og hva jeg trener, gir Bruce Studios meg friheten til å velge mellom hundrevis av treningssentre.',
      },
      {
        name: 'Julie Sofie Wichmann',
        image: '/images/ambassadors/julie-sofie-wichmann.webp',
        description:
          'Fysioterapeut, dansetrener, tidligere Verdensmester i dans',
        quote:
          'Som pensjonert toppidrettsutøver har jeg fått et stort hjerte for variasjon i treningshverdagen! Treningen som tidligere bestod av både faste og begrensede rutiner og mål, består nå av både styrketrening, løping, boksing, yoga m.m. Samtidig pusher Bruce Studios meg til å utfordre komfortsonen min ofte; nettopp ved å teste nye treningsformer med jevne mellomrom!',
      },
      {
        name: 'Nora Bendixen',
        image: '/images/ambassadors/nora-bendixen.webp',
        description: 'Medeier og SoMe-ansvarlig, Mash Balance',
        quote:
          'Bruce Studios er en genial idé som har bidratt til at Mash Studios har kommet i kontakt med utrolig mange, fantastiske kunder. Både personlig og som sentereier digger jeg hva Bruce Studios tilbyr og tror det er en markedstrend som har kommet for å bli!',
      },
      {
        name: 'Eivind Dahl Ringard',
        image: '/images/ambassadors/eivind-dahl-ringard.webp',
        description: 'Daglig leder, Crossfit Oslo',
        quote:
          'Vi bruker Bruce Studios til å fylle å studios der vi ser at vi har ledig kapasitet og at vi ikke har høy nok etterspørsel fra egne medlemmer. I tillegg har vi satt opp noen egne timer bare for Bruce Studios, fordi vi vil at flere og flere skal få prøve CrossFit og da er Bruce Studios en perfekt plattform for å hjelpe oss med det.',
      },
      {
        name: 'Sandra Angelil',
        image: '/images/ambassadors/sandra-angelil.webp',
        description: 'Daglig leder, Myrens treningssenter',
        quote:
          'Myrens har samarbeidet med Bruce Studios i mange år og det vi liker aller best er den kjappe responsen vi får fra Bruce Studios hvis det skulle være noe. I tillegg har de en integrert løsning som gjør den administrative jobben hos oss så enkel som mulig.',
      },
    ],
    WHY_BRUCE_TITLE: 'Hvorfor Bruce Studios?',
    WHY_BRUCE_ITEMS: [
      {
        ICON: 'ph-shuffle',
        TITLE: 'Variert trening',
        DESCRIPTION:
          'Tilgang til gym, svømming, klatring, yoga, padel, crossfit og mye mer.',
      },
      {
        ICON: 'ph-sparkle',
        TITLE: 'Unike opplevelser',
        DESCRIPTION:
          'Oppdag unike boutique studios som minner om alt fra en nattklubb i L.A. til et yoga retreat i India.',
      },
      {
        ICON: 'ph-hand-fist',
        TITLE: 'Frihet',
        DESCRIPTION:
          'Tren hva og hvor du vil. Det er ingen bindingstid, og du kan når som helst pause ditt medlemskap.',
      },
    ],
  },
  da: {
    TITLE: 'All\u00A0training. One\u00A0membership.',
    DESCRIPTION:
      'Get access to more than 1000 gyms, yoga studios, climbing centers, dance classes, HIIT boxes & swimming pools.',
    TRIAL_BUTTON: 'Prøv gratis i 14 dage',
    JOIN_BUTTON: 'Join Bruce Studios',
    EXPLORE_BUTTON: 'Udforsk alle studios',
    AMBASSADORS: [
      {
        name: 'Anders Roemer',
        image: '/images/ambassadors/anders-roemer.webp',
        description: 'Løber, Founder af NBRO Running, DJ, psykolog',
        quote:
          'Jeg elsker fleksibilitet med Bruce Studios. Jeg får adgang til flere forskellige studios rundt omkring i København, og bruger det især til at holde mit løb igang - især i koldere tider. Derudover er det sjovt at prøve nye ting af, såsom hot yoga!',
      },
      {
        name: 'Josephine Lydolph',
        image: '/images/ambassadors/josephine-lydolph.webp',
        description: 'Personlig træner, grundlægger af Movement with Lydolph',
        quote:
          'Jeg elsker at prøve forskellige træningsformer af og udfordre min krop. Gennem Bruce Studios kan jeg få lov til netop det. Jeg kan finde træningsformer jeg allerede elsker, samt nye træningsformer som jeg endnu ikke er kendt med, uden at det skal koste mig en bondegård at have abonnementer flere forskellige steder rundt omkring i byen.',
      },
      {
        name: 'Robin Bery',
        image: '/images/ambassadors/robin-bery.webp',
        description: 'Editor-in-chief, Agent & Influencer',
        quote:
          'Jeg er vild med Bruce Studios, da de samler forskellige aktiviteter under en fane. Selvom jeg primært holder mig til min faste rutine, såsom HIIT eller vægtløftning, er det en bonus at kunne afprøve noget nyt, og komme ud af sin comfort zone.',
      },
      {
        name: 'Philip Geisler',
        image: '/images/ambassadors/philip-geisler.webp',
        description: 'Selvstændig og Sportsentusiast, Influencer',
        quote:
          'Jeg elsker generelt at træne varieret og prøve nye træningsformer. Det kan jeg med Bruce Studios, hvilket er helt genialt! Jeg bruger primært Bruce Studios til Thaiboksning, Hot Yoga og Svømning og så prikker jeg sommetider til min comfortzone med en omgang Padel, Bouldering eller Åndedrætstræning, hvilket er super lærerigt. Med Bruce Studios er det nemt og det giver dig alle de træningsmuligheder du har brug for!',
      },
      {
        name: 'Adam Holm',
        image: '/images/ambassadors/adam-holm.webp',
        description: 'Founder af Blonde Inc',
        quote:
          'Jeg nyder virkelig fleksibiliteten, Bruce Studios giver mig til at træne hvad og hvor jeg vil. Jeg elsker at kombinere HIIT timer hos SHC og yogatimer hos Dóttir Hot Yoga. Og på samme tid blive ved med at opdage nye studios og aktiviteter.',
      },
      {
        name: 'Henriette Husby',
        image: '/images/ambassadors/henriette-husby.webp',
        description: 'Founder og Podcaster',
        quote:
          'Jeg elsker at kunne vælge akkurat, hvad jeg vil træne. Hvis jeg vil bokse en dag, så gør jeg det, hvis jeg vil svømme eller klatre, så gør jeg også det. Det er dét, jeg elsker med Bruce Studios. Jeg nyder at udforske nye træningsformer og studios - med Bruce Studios har jeg svømmet, bokset, klatret og prøvet Pole Dancing. Det er SJOVT!',
      },
    ],
    WHY_BRUCE_TITLE: 'Hvorfor Bruce Studios?',
    WHY_BRUCE_ITEMS: [
      {
        ICON: 'ph-shuffle',
        TITLE: 'Nyd varieret træning',
        DESCRIPTION:
          'Alle former for træning fra fitnesscenter, svømning og klatring til yoga, padel, crossfit og alt derimellem.',
      },
      {
        ICON: 'ph-sparkle',
        TITLE: 'Unikke oplevelser',
        DESCRIPTION:
          'Træn i unikke boutique-studios, der minder om alt fra en natklub i L.A. til et yoga-refugium i Indien.',
      },
      {
        ICON: 'ph-hand-fist',
        TITLE: 'Frihed',
        DESCRIPTION:
          'Træn, som du vil, hvor du vil. Der er ingen bindingsperiode, og du kan sætte dit medlemskab på pause, når du vil.',
      },
    ],
  },
} as const
